import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import './Banner.scss';

export type BannerVariant = 'success' | 'warning' | 'error';

type BannerProps = {
  variant: BannerVariant;
  title: string;
  description?: string;
};

const VARIANT_ICONS: Record<BannerVariant, React.ComponentType<{ className?: string }>> = {
  success: CheckCircleOutlineIcon,
  warning: WarningIcon,
  error: ErrorIcon,
};

const Banner: React.FC<BannerProps> = ({ variant, title, description }) => {
  const Icon = VARIANT_ICONS[variant];

  return (
    <div className={`banner banner--${variant}`}>
      <Icon className="banner__icon" />
      <p className="banner__text">
        <span className="banner__title">{title}</span>
        {description && <span className="banner__description">{description}</span>}
      </p>
    </div>
  );
};

export default Banner;
